// extracted by mini-css-extract-plugin
export default {"prompt":"prompt-tZVi","description":"description-faVn"};